<template>
    <b-container fluid>
        <b-row>
            <b-col class="mb-3 d-none d-md-block" cols="12" lg="2" md="4">
                <b-card class= "approved clickable" @click="$router.push('actions/approved')">
                    <b-card-title>Approved Actions</b-card-title>
                    <b-card-text>
                        {{ counts['approved'] }}
                        <sup>
                            <font-awesome-icon
                                    :icon="['far', 'arrow-right']"
                                    size="sm"
                            ></font-awesome-icon>
                        </sup>
                    </b-card-text>
                    <vue-element-loading :active="loading"></vue-element-loading>
                </b-card>
            </b-col>
            <b-col cols="12" lg="2" md="4">
                <b-card class= "actions clickable" @click="$router.push('actions')">
                        <b-card-title>Open Actions</b-card-title>
                        <b-card-text>
                            {{ totalCounts }}
                            <sup>
                                <font-awesome-icon
                                        :icon="['far', 'arrow-right']"
                                        size="sm"
                                ></font-awesome-icon>
                            </sup>
                        </b-card-text>
                        <vue-element-loading :active="loading"></vue-element-loading>
                </b-card>
            </b-col>
            <b-col class="mb-3 d-none d-md-block" cols="12" lg="2" md="4" v-if="$can($perm.ACTIONS_ASSIGN, $perm.PERMISSION_TYPE_ACTION)">
                <b-card class= "assigned clickable" @click="$router.push('actions/assigned')">
                        <b-card-title>Assigned</b-card-title>
                        <b-card-text>
                            {{ counts['assigned'] }}
                            <sup>
                                <font-awesome-icon
                                        :icon="['far', 'arrow-right']"
                                        size="sm"
                                ></font-awesome-icon>
                            </sup>
                        </b-card-text>
                        <vue-element-loading :active="loading"></vue-element-loading>
                </b-card>
            </b-col>
            <b-col class="mb-3 d-none d-md-block" cols="12" lg="2" md="4">
                <b-card class= "pending-approval clickable" @click="$router.push('actions/approvals')">
                        <b-card-title>Pending Approval</b-card-title>
                        <b-card-text>
                            {{ counts['pending approval'] }}
                            <sup>
                                <font-awesome-icon
                                        :icon="['far', 'arrow-right']"
                                        size="sm"
                                ></font-awesome-icon>
                            </sup>
                        </b-card-text>
                        <vue-element-loading :active="loading"></vue-element-loading>
                </b-card>
            </b-col>
            <b-col class="mb-3 d-none d-md-block" cols="12" lg="2" md="4">
                <b-card class= "no-access clickable" @click="$router.push('actions/no-access')">
                    <b-card-title>No Access</b-card-title>
                    <b-card-text>
                        {{ counts['no access'] }}
                        <sup>
                            <font-awesome-icon
                                    :icon="['far', 'arrow-right']"
                                    size="sm"
                            ></font-awesome-icon>
                        </sup>
                    </b-card-text>
                    <vue-element-loading :active="loading"></vue-element-loading>
                </b-card>
            </b-col>
            <b-col class="mb-3 d-none d-md-block" cols="12" lg="2" md="4">
                <b-card class= "queries cursor" @click="$router.push('actions/queries')">
                    <b-card-title>Queries</b-card-title>
                    <b-card-text>
                        {{ counts['query'] }}
                        <sup>
                           <font-awesome-icon
                                   :icon="['far', 'arrow-right']"
                                   size="sm"
                           ></font-awesome-icon>
                        </sup>
                    </b-card-text>
                    <vue-element-loading :active="loading"></vue-element-loading>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ActionCountWidgets',
  data() {
    return {
      loading: false,
      totalCounts: 0,
      totalPropertyCount: 0,
    };
  },
  computed: {
    ...mapGetters([
      'counts',
    ]),
    getPropertyClass() {
      if (this.$can(this.$perm.PROPERTIES_VIEW_PROPERTIES, this.$perm.PERMISSION_TYPE_PROPERTIES)) {
        return 'properties clickable';
      }

      return 'properties';
    },
  },
  mounted() {
    this.$store.dispatch('refreshPropertyCounts');
  },
  watch: {
    counts(newCounts) {
      const keys = Object.keys(newCounts);
      const values = Object.values(newCounts);
      const excludeKeys = [
        'approved',
        //'pending approval',
        //'query',
      ];

      this.totalCounts = values.reduce((accumulator, number, key) => {
        const status = keys[key];
        if (excludeKeys.includes(status)) {
          return accumulator;
        }
        if (number !== null) {
          return accumulator + number;
        }
      }, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
    div.card {
        background: #d4e7f8 0% 0% no-repeat padding-box;
        border: 0;
        box-shadow: 0px 4px 0px rgba(5, 108, 199, 0.25);
        border-radius: 3px;
        margin-bottom: 1em;
        font-weight: 700;
        &.clickable {
            cursor: pointer;
        }
        &.approved {
            background-color: #F59E08;
            color: #FFF;
            box-shadow: 0px 4px 0px #D98C06;
            .card-text {
                color: #FFF;
            }
        }
        &.actions {
            background-color: #24415E;
            color: #FFF;
            box-shadow: 0px 4px 0px #101D2B;
            .card-text {
                color: #FFF;
            }
        }
        &.assigned {
            background-color: #476078;
            color: #FFF;
            box-shadow: 0px 4px 0px #2F4050;
            .card-text {
                color: #FFF;
            }
        }
        .card-title {
            font-size: 16px;
            font-weight: 700;
            margin-bottom: 0px;
            height: 50px;
        }
        .card-text {
            font-weight: 700;
            font-size: 26px;
            color: #4E738A;
            margin-bottom: 0;
            sup {
                font-size: 16px;
            }
        }
    }

    @media screen and (max-width: 991px) {
        div.card {
            .card-title {
                margin-bottom: 10px;
            }
        }
    }
</style>
